/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Grid,
  Container,
  Box,
  Divider,
  TextField,
  FormControlLabel,
  Switch,
} from "@mui/material";
import CustomModal from "../../modals/CustomModal";
import SaveCancelButtons from "../../SaveCancelButtons";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { ModeloPost, ModeloUpdate } from "../../ModeloCrud";
import { useLiquidaciones } from "../contexts/LiquidacionesContext";
import { useLiquidarUtils } from "../hooks/useLiquidarUtils";
import { useAuditoria } from "../contexts/AuditoriaContext";

const validationSchema = yup.object({
  nombre: yup
    .string()
    .required("Campo obligatorio")
    .min(5, "Debe tener al menos 5 caracteres")
    .max(50, "Debe tener como máximo 50 caracteres"),
  habilitada: yup.boolean().required(),
});

export default function ModalListaHonorariosForm({
  showModal,
  hideModal,
  listaRow = null,
}) {
  const [myloading, setMyLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const { listasActivas, listasHonorariosRows } = useLiquidaciones();
  const { updateAuditoria } = useAuditoria();
  const { fetchListas } = useLiquidarUtils();

  const handleClose = () => {
    formik.resetForm();
    hideModal();
  };

  const formik = useFormik({
    initialValues: {
      nombre: listaRow?.nombre || "",
      habilitada: listaRow?.habilitada === 1 || !listaRow,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      await grabar(values);
    },
  });

  async function grabar(values) {
    const Data = {
      nombre: values.nombre,
      habilitada: values.habilitada ? 1 : 0,
    };

    const operacion = listaRow ? "PUT" : "POST";
    let result = "";
    setSaving(true);
    if (operacion === "PUT") {
      result = await ModeloUpdate(
        "listas-precios-honorarios",
        listaRow.id,
        Data
      );
    } else {
      result = await ModeloPost("listas-precios-honorarios", null, null, Data);
    }
    setSaving(false);

    if (result?.error === false) {
      toast.success("Lista guardada correctamente.");
      fetchListas(listasActivas);
      updateAuditoria({
        selectedListaHonorarios: {
          id: result.listado[0].id,
          nombre: values.nombre,
          habilitada: values.habilitada ? 1 : 0,
        },
      });
      handleClose();
    } else {
      toast.error(result?.errormessage || "Error al guardar la lista.");
    }
  }

  return (
    <CustomModal
      open={showModal}
      onClose={handleClose}
      title={
        listaRow ? "Editar Lista de Honorarios" : "Nueva Lista de Honorarios"
      }
      disableActions
      maxWidth="sm"
      icon={
        listaRow ? (
          <EditIcon fontSize="medium" sx={{ color: "white" }} />
        ) : (
          <AddIcon fontSize="medium" sx={{ color: "white" }} />
        )
      }
    >
      <Container maxWidth="sm">
        <form onSubmit={formik.handleSubmit}>
          <Grid container sx={{ mt: 2 }} spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="nombre"
                label="Nombre de la Lista"
                value={formik.values.nombre}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                helperText={formik.touched.nombre ? formik.errors.nombre : ""}
                error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    id="habilitada"
                    checked={formik.values.habilitada}
                    onChange={(e) =>
                      formik.setFieldValue("habilitada", e.target.checked)
                    }
                    color="primary"
                  />
                }
                label="Habilitada"
              />
            </Grid>
          </Grid>

          <Divider sx={{ mt: 3 }} />

          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <SaveCancelButtons
              handleCancel={handleClose}
              loading={saving}
              isModal={true}
            />
          </Box>
        </form>
      </Container>
    </CustomModal>
  );
}
